import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, InputBase } from "@mui/material";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import debounce from "lodash/debounce";
import React, { useCallback, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import DivisionCmp from "../../../../components/cards/DivisionCmp";
import PercentageCard from "../../../../components/cards/PercentageCard";
import TableCreator from "../../../../components/table/tableCreator";
import { ApiResultModel, ColumnModel } from "../../../../models/common.model";
import { GetStoreResponse } from "../../../../models/store.model";
import { DeleteStore, GetStore } from "../../../../services/store.service";
import "./storeDetail.css";
import StoreDetailSkeleton from "./storeDetailSkeleton";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { BRANCHID, CACHEROUTE, STOREID } from "../../../../config/cacheKey";
import ModalCancel from "../../../../components/modals/ModalCancel";
import { toast } from "react-toastify";
import { BranchDelete } from "../../../../services/branch.service";
import { IBranchRequest } from "../../../../models/branch.model";

export default function StoreDetail() {
  const [storeData, setStoreData] = useState<GetStoreResponse | undefined>();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [filteredData, setFilteredData] = useState<IBranchRequest[]>([]);
  const [showTable, setshowTable] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  localStorage.removeItem(CACHEROUTE);
  const columns: readonly ColumnModel[] = [
    { id: "branchTypeTitle", label: "نوع شعبه" },
    { id: "branchStoreTitle", label: "عنوان شعبه" },
    { id: "isActive", label: "وضعیت شعبه" },
    { id: "iban", label: "شماره شبا" },
    { id: "provinceCityTitle", label: "شهر محل فعالیت" },
    // { id: "address", label: "آدرس" },
  ];

  const {
    mutateAsync: getStoreDetailMutate,
    isLoading: getStoreDetailLoading,
  } = useMutation(GetStore, {
    onSuccess: (data: ApiResultModel<GetStoreResponse>) => {
      setStoreData(data.data);
      setFilteredData(data.data?.branches || []);
      if (data.data?.branches && data.data?.branches.length > 0) {
        setshowTable(true);
      }
    },
  });
  const { mutateAsync: DeleteStoreMutate } = useMutation(DeleteStore, {
    onSuccess: (data: ApiResultModel<string>) => {
      if (data.isSuccess) {
        toast.success(data.data);
        history.push("/store");
        setOpenModal(false);
      }
    },
  });
  const { mutateAsync: BranchDeleteMutate } = useMutation(BranchDelete, {
    onSuccess: (data: ApiResultModel<boolean>) => {
      if (data.isSuccess) {
        toast.success("عملیات با موفقیت انجام شد");
        if (storeId) {
          getStoreDetailMutate({ storeId: storeId });
        }
      }
    },
  });
  const storeId = Number(localStorage.getItem(STOREID));
  useEffect(() => {
    if (storeId) {
      getStoreDetailMutate({ storeId: storeId });
    } else {
      history.push("/store");
    }
  }, []);

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      if (storeData?.branches) {
        const filtered = storeData.branches.filter((branch) =>
          columns.some(
            (column) =>
              column.id &&
              branch[column.id as keyof IBranchRequest]
                ?.toString()
                .toLowerCase()
                .includes(value.toLowerCase())
          )
        );
        setFilteredData(filtered);
      }
    }, 300),
    [storeData]
  );
  const handleDeleteStore = () => {
    DeleteStoreMutate({ storeId: storeId });
  };

  const handleDeleteBranch = (e: any) => {
    BranchDeleteMutate({ id: e });
  };
  const handleEditBranch = (e: any) => {
    localStorage.setItem(BRANCHID, e);
    history.push("/store/BranchRegister");
  };
  const handleSearchInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };

  const history = useHistory();
  const table = (
    <div className='px-4'>
      {showTable ? (
        <>
          <div dir='ltr'>
            <Paper
              elevation={0}
              style={{
                border: ".9px solid #DAE0E4",
                display: "flex",
                borderRadius: "3px",
                height: "35px",
                width: "20vw",
                marginRight: "10px",
                margin: "10px",
                direction: "rtl",
                marginLeft: "0px",
              }}
              square={true}
            >
              <InputBase
                sx={{
                  ml: 1,
                  flex: 1,
                  paddingX: "16px",
                  height: "30px !important",
                }}
                placeholder='جستجو'
                onChange={handleSearchInput}
                value={searchTerm}
              />
              <IconButton
                type='button'
                sx={{ color: "#9AAFC4" }}
                aria-label='search'
              >
                <SearchIcon />
              </IconButton>
            </Paper>
          </div>
          {filteredData && filteredData.length > 0 ? (
            <TableCreator
              columns={columns}
              data={filteredData}
              pageInfo={undefined}
              handleDeleteBranch={handleDeleteBranch}
              handleEditBranch={handleEditBranch}
            />
          ) : (
            <span
              className='cardEmptyTable'
              style={{ color: "#C1C7CB", fontSize: "16px" }}
            >
              <div>
                <img src='./images/emptyStore.png' alt='img' />
              </div>
              شعبه‌ای یافت نشده است
            </span>
          )}
        </>
      ) : (
        <span
          className='cardEmptyTable'
          style={{ color: "#C1C7CB", fontSize: "16px" }}
        >
          <div>
            <img src='./images/emptyStore.png' alt='img' />
          </div>
          شعبه‌ای ثبت نشده است
        </span>
      )}
    </div>
  );

  if (getStoreDetailLoading) {
    return <StoreDetailSkeleton />;
  }
  return (
    <Grid container spacing={2}>
      {/* Banner */}
      <Grid
        item
        xs={12}
        style={{
          height: "20rem",
          textAlign: "left",
          backgroundColor: "#F5F5F5",
        }}
        className='w-full h-[20rem] overflow-hidden'
      >
        <img
          src={
            storeData?.bannerUrl
              ? storeData?.bannerUrl
              : "images/emptyBanner.png"
          }
          // src={
          //   storeData?.bannerLarge
          //     ? `data:image/png;base64,${storeData?.bannerLarge}`
          //     : "images/emptyBanner.png"
          // }
          alt='img'
          className='w-full h-full object-contain storeBanner'
        />
      </Grid>
      {/* Menu */}
      <Grid
        item
        xs={12}
        className='defualtColor'
        container
        style={{ paddingTop: "20px" }}
      >
        <Grid item xs={4}>
          <div style={{ display: "inline-block" }}>
            <img
              src={
                storeData?.logoUrl
                  ? storeData?.logoUrl
                  : "images/emptyStoreLogo.png"
              }
              className='storeIcon'
              alt='img'
            />
          </div>
          <b
            style={{
              display: "absolute",
              marginRight: "160px",
              fontSize: "17px",
            }}
          >
            {storeData?.title}
            {storeData?.isActive ? (
              <b style={{ color: "#01AF43", fontSize: ".9rem" }}>
                &nbsp;(فعال)&nbsp;
              </b>
            ) : (
              <b style={{ color: "#FB8C00", fontSize: ".9rem" }}>
                &nbsp;(غیرفعال)&nbsp;
              </b>
            )}
          </b>
        </Grid>
        <Grid item xs={8} textAlign={"left"} sx={{ paddingLeft: "20px" }}>
          <span
            className='hoverForMenuOrBtn'
            style={{ fontSize: "15px", cursor: "pointer", padding: "5px 3px" }}
            onClick={() => {
              localStorage.removeItem(BRANCHID);
              history.push("/store/BranchRegister");
            }}
          >
            <AddCircleOutlineIcon /> افزودن شعبه جدید
          </span>
          <span style={{ margin: "0px 10px" }}>|</span>
          <span
            className='hoverForMenuOrBtn'
            style={{ fontSize: "15px", cursor: "pointer", padding: "5px 3px" }}
            onClick={() => {
              // localStorage.setItem(STOREID, String(storeId));
              history.push("/store/CreateStore");
            }}
          >
            <ModeEditOutlineOutlinedIcon /> ویرایش اطلاعات فروشگاه
          </span>
          <span style={{ margin: "0px 10px" }}>|</span>
          <span
            className='hoverForMenuOrBtn_ErrorStyle'
            style={{
              fontSize: "15px",
              cursor: "pointer",
              padding: "5px 3px",
              color: "#E6123D",
            }}
            onClick={() => setOpenModal(true)}
          >
            <DeleteOutlineOutlinedIcon /> حذف فروشگاه
          </span>
        </Grid>
      </Grid>
      {/* Categories */}
      <Grid item xs={12} container className='categoriStore'>
        <Grid
          item
          xs={12}
          md={6}
          container
          className='categoriStoreColOne categoriStoreCol'
        >
          <Grid xs={12} className='defualtColor'>
            <b>دسته بندی کالا</b>
          </Grid>
          <Grid container sx={{ display: "flex" }}>
            {storeData?.storeCategories.map((item, index) => (
              // <Grid
              // item
              // xs={12}
              // sm={6}
              // md={4}
              // key={index}
              // sx={{ marginBottom: "10px" }}
              // >
              <PercentageCard
                percentage={item.settlementPercentage}
                title={item.name}
              />
              // </Grid>
            ))}
          </Grid>
          <Grid
            xs={12}
            container
            className='defualtColor'
            style={{
              borderTop: "1px solid #CFD8DC",
              padding: "20px 10px",
              marginTop: "10px",
            }}
          >
            <Grid xs={6}>
              <b>درصد پیش فرض تسویه حساب: </b>
              <span> {storeData?.settlementPercentage}%</span>
            </Grid>
            <Grid xs={6}>
              <b>مهلت تسویه حساب: </b>
              <span>{storeData?.settlementDeadlineDays} روز</span>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6} className='defualtColor categoriStoreCol'>
          <b> توضیحات:</b>{" "}
          <span
            className='secondColor-100'
            style={{ lineHeight: "30px", textAlign: "justify" }}
          >
            {storeData?.description}
          </span>
        </Grid>
      </Grid>
      {/* Table */}
      <Grid item xs={12}>
        <div className='' style={{ paddingRight: "5px" }}>
          <DivisionCmp title='اطلاعات شعب‌' child={table} />
        </div>
      </Grid>
      <ModalCancel
        title={""}
        bgColor={"kamanColor"}
        setValue={handleDeleteStore}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
    </Grid>
  );
}
